import React from "react";
import styles from "../../styles/components/common/ErrorBoundary.module.css";
import { FaExclamationTriangle, FaRedo, FaHome } from "react-icons/fa";
import { isDevelopment } from "../../config/env";
import {
  isChunkLoadError,
  reloadOnceForChunkError,
  reloadPage,
  reportRenderError,
} from "../../utils/renderCrash";

class ProfileErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null,
    };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    reportRenderError(error, errorInfo, "ProfileErrorBoundary");
    reloadOnceForChunkError(error);

    this.setState({
      error,
      errorInfo,
    });
  }

  handleRetry = () => {
    if (isChunkLoadError(this.state.error)) {
      reloadPage();
      return;
    }
    this.setState({
      hasError: false,
      error: null,
      errorInfo: null,
    });
  };

  handleGoHome = () => {
    // Navigate to home page
    window.location.href = "/";
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className={styles.errorBoundaryContainer}>
          <div className={styles.errorCard}>
            <div className={styles.errorIcon}>
              <FaExclamationTriangle size={64} />
            </div>
            <h1 className={styles.errorTitle}>Something went wrong</h1>
            <p className={styles.errorMessage}>
              We encountered an unexpected error while loading your profile.
              Don't worry, your data is safe.
            </p>

            {/* Show error details in development */}
            {isDevelopment && this.state.error && (
              <details className={styles.errorDetails}>
                <summary>Error Details (Development Only)</summary>
                <pre className={styles.errorStack}>
                  {this.state.error.toString()}
                  {this.state.errorInfo && this.state.errorInfo.componentStack}
                </pre>
              </details>
            )}

            <div className={styles.errorActions}>
              <button
                type="button"
                onClick={this.handleRetry}
                className={styles.retryButton}
              >
                <FaRedo /> Try Again
              </button>
              <button
                type="button"
                onClick={this.handleGoHome}
                className={styles.homeButton}
              >
                <FaHome /> Browse Categories
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ProfileErrorBoundary;
